import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Construction } from 'lucide-react';

export const PlaceholderPage = ({ title, description }) => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-heading font-bold text-primary-900">{title}</h1>
        <p className="text-muted-foreground">{description}</p>
      </div>
      
      <Card>
        <CardContent className="pt-6">
          <div className="flex flex-col items-center justify-center py-12 text-center">
            <div className="h-16 w-16 rounded-full bg-secondary/10 flex items-center justify-center mb-4">
              <Construction className="h-8 w-8 text-secondary" />
            </div>
            <h3 className="text-lg font-semibold text-primary-900 mb-2">
              Yapım Aşamasında
            </h3>
            <p className="text-muted-foreground max-w-md">
              Bu sayfa henüz geliştirme aşamasındadır. Yakında kullanıma açılacaktır.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

// Specific placeholder pages
export const StudentsPage = () => (
  <PlaceholderPage 
    title="Öğrenciler" 
    description="Tüm öğrencileri görüntüleyin ve yönetin"
  />
);

export const ClassesPage = () => (
  <PlaceholderPage 
    title="Sınıflar" 
    description="Sınıfları ve öğrenci kayıtlarını yönetin"
  />
);

export const ScreeningsPage = () => (
  <PlaceholderPage 
    title="Tarama Dönemleri" 
    description="Tarama dönemlerini oluşturun ve takip edin"
  />
);

export const ReportsPage = () => (
  <PlaceholderPage 
    title="Raporlar" 
    description="Detaylı raporlar oluşturun ve dışa aktarın"
  />
);

export const SettingsPage = () => (
  <PlaceholderPage 
    title="Kurum Ayarları" 
    description="Kurum ayarlarını yapılandırın"
  />
);

export default PlaceholderPage;
